import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  init() {
    const video = this.el.querySelector('[data-intro-video]')
    const playButton = this.el.querySelector('[data-intro-play]')

    if (!video || !playButton) return

    const showOverlay = () => {
      this.el.classList.remove('is-playing')
    }

    const hideOverlay = () => {
      this.el.classList.add('is-playing')
    }

    const enableControls = () => {
      video.controls = true
    }

    playButton.addEventListener('click', () => {
      enableControls()
      video.play()
    })

    video.addEventListener('play', hideOverlay)

    video.addEventListener('ended', showOverlay)

    video.addEventListener('pause', () => {
      if (video.currentTime === 0 || video.ended) {
        showOverlay()
      }
    })
  }
}
